export default (context) => {
  const M = "admPublication."
  return {
    config: {
      resource: "admPublication",
      pageSize: 40,
      list: false,
      remapRow: (form) => {
        return form
      }
    },

    actions: {
      create: true,
      edit: true,
      delete: true,
      print: true,
      export: true,
      search: true
    },

    form: {
      remapOne: (r) => {
        if (r.status >= 0) {
          r.data.categoryId = { value: r.data.categoryId, label: r.data.categoryName }
        }
        return r
      },
      setValuesBeforePost: (v) => {
        return v
      },
      fields: [
        {
          col: 12,
          name: "tab1",
          value: false,
          type: "collapsible",
          label: `${M}firstLanguage`,
          placeholder: `${M}enterFirstLanguage`,
          childs: [
            {
              col: 12,
              name: "name",
              value: "",
              type: "text",
              label: "main.title",
              rules: "required",
              opts: {
                style: 'float-label',
              }
            },
            {
              col: 12,
              name: "desc",
              value: "",
              type: "text",
              label: "main.desc",
              rules: "required",
              opts: {
                style: 'float-label',
              }
            },
            {
              col: 12,
              name: "body",
              value: "",
              type: "editor",
              label: `${M}longComment`,
              rules: "required"
            }
          ]
        },
        {
          col: 12,
          name: "tab2",
          value: false,
          type: "collapsible",
          label: `${M}secondaryLanguage`,
          placeholder: `${M}enterSecondaryLanguage`,
          childs: [
            {
              col: 12,
              name: "nameEN",
              value: "",
              type: "text",
              label: "main.title",
              opts: {
                style: 'float-label',
              }
            },
            {
              col: 12,
              name: "descEN",
              value: "",
              type: "text",
              label: "main.desc",
              opts: {
                style: 'float-label',
              }
            },
            {
              col: 12,
              name: "bodyEN",
              value: "",
              type: "editor",
              label: `${M}longComment`,
            }
          ]
        },
        {
          col: 12,
          name: "by",
          value: "",
          type: "text",
          label: "main.author",
          opts: {
            style: 'float-label',
          }
        },
        {
          col: 12,
          name: "imgUrl",
          value: "",
          type: "dropzone",
          label: "main.coverImage",
          isDoc: false,
          rules: 'ext:jpeg,jpg,png',
          opts: {
            path: ()=> "/admPublication/file",
            accept: '.jpeg,.jpg,.png',
            output: true
          }
        },
        {
          col: 4,
          name: "superSections",
          value: "",
          type: "select",
          label: `${M}visibleForSections`,
          opts: {
            style: 'float-label',
            path: "/admSuperSection/get?pick=true",
            isMulti: true,
            setOutput: v => v
          }
        },
        {
          col: 4,
          name: "sections",
          value: "",
          type: "select",
          label: `${M}visibleToSubsections`,
          parent: 'superSections',
          opts: {
            style: 'float-label',
            path: () => `/admSection/get?pick=true&parentId=${context.state.form.superSections[0].value}`,
            isMulti: true,
            setOutput: v => v
          },
          renderIf: ctx => ctx.state.superSections && ctx.state.superSections.length === 1
        },
        {
          col: 4,
          name: "categoryId",
          value: "",
          type: "select",
          label: "main.category",
          rules: 'required',
          opts: {
            style: 'float-label',
            path: () => "/admCategory/get?type=pub"
          }
        },
        {
          col: 12,
          name: "empty1",
          type: "separator",
        },
        {
          col: 4,
          name: "pinTop",
          value: false,
          type: "switch",
          label: `${M}importantPin`
        },
        {
          col: 12,
          name: "labelSpacer",
          value: L => `<h3>${L[`${M}whoCanSee`]}</h3>`,
          type: "label"
        },
        {
          col: 4,
          name: "accessPrincipal",
          value: true,
          type: "switch",
          label: `${M}mainUsers`
        },
        {
          col: 4,
          name: "accessDependant",
          value: true,
          type: "switch",
          label: `${M}dependentUsers`
        },
        {
          col: 4,
          name: "accessMaster",
          value: true,
          type: "switch",
          label: `${M}staffTeachers`
        }
      ]
    },

    columns: [
      {
        Header: "main.ID",
        accessor: "ID"
      },
      {
        Header: "main.name",
        accessor: "name"
      },
      {
        Header: "main.desc",
        accessor: "desc"
      },
      {
        Header: `${M}published`,
        accessor: "pinTop",
        isBool: true
      }
    ]
  }
}